export default "__VITE_ASSET__d8e304be__"